/**
 * Where the Dooglie Chrome extension is addressed from.
 *
 * The id is per channel: the store extension ("Dooglie", key pinned in its
 * manifest) for production, and the separately keyed "Dooglie (Dev)" extension
 * for the hosted dev build and localhost. Each env file names its own
 * `VITE_EXTENSION_ID`; there is no fallback, because a dev webapp that quietly
 * talked to the store extension would hand dev sessions to a prod install.
 */
import { IS_PRODUCTION_CHANNEL, requireEnv } from './channel';

export const DOOGLIE_EXTENSION_ID = requireEnv(
  'VITE_EXTENSION_ID',
  import.meta.env.VITE_EXTENSION_ID
);

/**
 * Where "Download extension" sends someone. The store only carries the
 * production extension; on any other channel the dev extension is on the
 * downloads page.
 */
export const EXTENSION_INSTALL_URL = IS_PRODUCTION_CHANNEL
  ? `https://chromewebstore.google.com/detail/dooglie-chrome-extension/${DOOGLIE_EXTENSION_ID}`
  : '/downloads';
